import type { SpaceScale } from '@shopify/polaris-tokens';
import type { EmptyStateProps } from '@shopify/polaris';

import { EmptyState } from '@shopify/polaris';

type Gap = SpaceScale;
export interface GEmptyStateProps extends EmptyStateProps {
  gap?: Gap;
}

export const GEmptyState: React.FC<GEmptyStateProps> = ({ gap, ...props }) => {
  return (
    <div
      className={'Polaris-GEmptyState'}
      {...(gap && {
        style: { '--gx-pc-block-stack-gap-xs': `var(--p-space-${gap})` } as React.CSSProperties,
      })}
    >
      <EmptyState {...props}></EmptyState>
    </div>
  );
};
